import {
    GET_ALL_WAREHOUSES,
    CLEAR_RESPONSE,
    RESPONSE_STATUS,
} from './shipStationTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_WAREHOUSES:
            return {
                ...state,
                all_warehouses: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
